import React, {useState} from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Confirm from '../components/modal/Confirm';
import axios from '../api/axios';

const links = [
  {
    href: "/e-prescription",
    icon: "https://img.icons8.com/ios-filled/24/007E7A/calendar.png",
    label: "E-Prescription",
  },
  {
    href: "/home",
    icon: "https://img.icons8.com/ios-filled/24/007E7A/home.png",
    label: "Home",
  },
  {
    href: "/akun",
    icon: "https://img.icons8.com/ios-filled/24/007E7A/user.png",
    label: "Profile",
  },
];

interface BottomNavProps {
  fromUrl?: string; // Optional URL prop for future use
  user_id?: number;
  teleconsult_id?: number;
  token?: string;
}

const BottomNav: React.FC<BottomNavProps> = ({fromUrl, user_id, teleconsult_id, token}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleConfirmExit = async () => {
    setIsLoading(true);
    try {
      const response = await axios.post(
        `teleconsultation/cancel`,
        {
          user_id,
          teleconsult_id,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );


      setShowModal(false);
      navigate('/home'); // navigasi setelah cancel berhasil
    } catch (error) {
      console.error('❌ Gagal membatalkan konsultasi:', error);
      alert('Terjadi kesalahan saat membatalkan konsultasi.');
    } finally {
      setIsLoading(false);
    }
  };


  const isDisclaimerRoute = fromUrl?.includes('/connect-doctor/');
    return (
      <nav
        style={{
          position: "fixed",
          bottom: 0,
          width: "100%",
          backgroundColor: "#FFFFFF",
          display: "flex",
          justifyContent: "space-between",
          padding: "10px 0",
          boxShadow: "0 -2px 5px rgba(0,0,0,0.1)",
          zIndex: 1000,
        }}
      >
        {links.map(({ href, icon, label }) => {
          const isActive = location.pathname.startsWith(href);
          return (
            <button
              key={href}
              onClick={() => {
                if (isDisclaimerRoute) {
                  setShowModal(true);
                } else {
                  navigate(href)
                }
              }}
              className={`loader_overlay ${isActive ? "active" : ""}`}
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                flex: 1,
                textDecoration: "none",
                background: "none",
                border: "none",
                color: "#007E7A",
                cursor: "pointer",
              }}
            >
              <img
                src={icon}
                alt={label}
                style={{
                  marginBottom: "5px",
                  filter: isActive ? "none" : "grayscale(100%)",
                }}
              />
              <div
                style={{
                  fontSize: "12px",
                  filter: isActive ? "none" : "grayscale(100%)",
                }}
              >
                {label}
              </div>
            </button>
          );
        })}
        <Confirm
          show={showModal}
          title="Batalkan Konsultasi"
          message="Keluar dari halaman ini akan membatalkan permintaan konsultasi. Yakin ingin keluar?"
          confirmText="Keluar"
          cancelText="Batal"
          onConfirm={handleConfirmExit}
          onCancel={() => setShowModal(false)}
          loading={isLoading}
        />
      </nav>
      
    );
  };

export default BottomNav;
